var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"21814e5694e922c23f83d9ca5819a41d72f4c2ed"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["buscounchollo-prod@sentry"]={id:"21814e5694e922c23f83d9ca5819a41d72f4c2ed"};
      